module.exports = __webpack_public_path__ + "static/media/logo.6d6c2bcd.png";